export class StudyInfo {
    constructor() {
        this.initBaseAttributes();
    }

    initBaseAttributes() {
        this.StudyInstanceUID = '';
        this.StudyDate = '';
        this.StudyTime = '';
        this.AccessionNumber = '';
        this.ReferringPhysicianName = '';
        this.PatientName = '';
        this.PatientID = '';
        this.PatientBirthDate = '';
        this.PatientSex = '';
        this.StudyID = '';
        this.NumberOfStudyRelatedSeries = '';
        this.NumberOfStudyRelatedInstances = '';
        this.StudyDescription = '';
        this.ModalitiesInStudy = '';
    }
}